export default __webpack_public_path__ + "static/media/location_icon.82af16d5.svg";